import { ArrowLeftIcon } from '../../icons';
import Button from '../base/buttons/Button';
import MantleHorizontalLockupPrimary from '../logos/MantleHorizontalLockupPrimary';

interface IWizardHeaderProps {
  onBack?: () => void;
}

const WizardHeader = ({ onBack }: IWizardHeaderProps) => {
  const showBackButton = !!onBack;

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center">
        {showBackButton && <Button onClick={onBack} size="sm" color="tertiary" iconLeading={ArrowLeftIcon} />}
      </div>

      <div className="flex flex-1 items-center justify-center">
        <MantleHorizontalLockupPrimary className="h-8 w-auto shrink-0" role="img" aria-label="Mantle" />
      </div>

      <div className="flex flex-1 justify-end" />
    </div>
  );
};

export default WizardHeader;
